import axios from 'axios';
import { Logger } from './loggers';

export class HttpHelper {
    static cache = {};
    static axiosInstance = axios.create({
        headers: {
            'Content-Type': 'application/json',
        },
    });

    static async get(url, options = {}) {
        return this.axiosInstance.get(url, options);
    }

    static async post(url, body, options = {}) {
        return this.axiosInstance.post(url, body, options);
    }

    static async put(url, body, options = {}) {
        return this.axiosInstance.put(url, body, options);
    }

    static async fetch(url, options = {}) {
        const config = {
            method: options.method || 'GET',
            headers: options.headers || {},
            data: options.body,
            signal: options.abortController?.signal,
        };

        if (options.queryParams) {
            config.params = options.queryParams;
        }

        try {
            const response = await this.axiosInstance(url, config);
            return response.data;
        } catch (error) {
            Logger.logError('[ERROR]: Error fetching url:', url, ', getting error:', error);
            throw error;
        }
    }

    static async fetchWithRetry(url, options = {}, retryCount = 3) {
        for (let i = 0; i < retryCount; i++) {
            try {
                return await this.fetch(url, options);
            } catch (error) {
                if (i === retryCount - 1) throw error;
                await this.delayedPromise(null, 1000 * Math.pow(2, i)); // Exponential backoff
            }
        }
    }

    static requestQueue = new Map();

    static async queueRequest(key, request) {
        if (this.requestQueue.has(key)) {
            return this.requestQueue.get(key);
        }

        const promise = request();
        this.requestQueue.set(key, promise);

        try {
            return await promise;
        } finally {
            this.requestQueue.delete(key);
        }
    }
}
